import React from 'react';

import useSafeState from '../../../../../../../useSafeState' 
import * as api from '../../../../../../../Auth/auth'
import TableComp from '../../../../../../../components/Table/TableComp';



export function Struct_TableData() {

  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(React.useMemo(() => []));
  const [loading, setLoading] = React.useState(false);
    
    React.useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    const response = await api.struct();
    const d = handleData(response)
    setData( d )
    setLoading(false)
           // NO MEMORY LEAK
    setValue({ key: 'value' });
    }



    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {    'col1': response[i].id,
                                            'col2': response[i].Sample,
                                            'col3': response[i].Uploaded_variation,
                                            'col4': response[i].CHROM,
                                            'col5': response[i].START,
                                            'col6': response[i].END,
                                            'col7': response[i].GENE,
                                            'col8': response[i].SVTYPE,
                                            'col9': response[i].DISEASE_TRAIT,
                                            'col10': response[i].PUBMED,
                                            'col11': response[i].FREQUENCY,
                                            'col12': response[i].owner,
                                        },
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
        {
          header: 'ID',
          accessorKey: 'col1',
          cell: info => info.getValue()
        },
        {
        header: 'Sample',
        accessorKey: 'col2',
        cell: info => info.getValue()
      },
      {
        header: 'Gene',
        accessorKey: 'col7',
        cell: info => info.getValue()
      },
            {
             header: 'Struct. Variant',
            accessorKey: 'col3',
            cell: info => info.getValue()
              },
              {
               header: 'Chromosome',
              accessorKey: 'col4',
              cell: info => info.getValue()
                },
                {
                    header: 'Start',
                    accessorKey: 'col5',
                    cell: info => info.getValue()
                    },
                    {
                        header: 'End',
                    accessorKey: 'col6',
                    cell: info => info.getValue()
                        },
                        {
                          header: 'SV Type',
                        accessorKey: 'col8',
                        cell: info => info.getValue()
                          },
                        {
                            header: 'Trait',
                            accessorKey: 'col9',
                            cell: info => info.getValue()
                          },
                        {
                          header: 'PubMed',
                          accessorKey: 'col10',
                          cell: info => info.getValue()
                        },                        
      ],
      []
      )

return (

<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableComp columns={columns} data={data} />
</div>
);
}